import { render, staticRenderFns } from "./search-bar.vue?vue&type=template&id=2517d8d8&scoped=true&"
import script from "./search-bar.vue?vue&type=script&lang=js&"
export * from "./search-bar.vue?vue&type=script&lang=js&"
import style0 from "./search-bar.vue?vue&type=style&index=0&id=2517d8d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2517d8d8",
  null
  
)

export default component.exports